export const breakpointSizes = {
  navbarFixed: { min: 1200, max: Number.MAX_SAFE_INTEGER },
  xxs: { min: 1, max: 479.98 },
  xs: { min: 480, max: 767.98 },
  sm: { min: 768, max: 991.98 },
  md: { min: 992, max: 1199.98 },
  lg: { min: 1200, max: 1499.98 },
  xl: { min: 1500, max: Number.MAX_SAFE_INTEGER },
}

type SizeMap = {
  [breakpoint: string]: {
    min?: number;
    max: number;
  }
}

export function buildMediaQueryUp(sizes: SizeMap) {
  return Object.entries(sizes).reduce((acc, [label, val]) => {
    const minWidth = val.min
    if (minWidth) {
      acc[label] = `@media (min-width: ${minWidth}px)`
    }
    return acc
  }, {})
}

export function buildMediaQueryDown(sizes: SizeMap) {
  return Object.entries(sizes).reduce((acc, [label, val]) => {
    const maxWidth = val.max
    acc[label] = `@media (max-width: ${maxWidth}px)`
    return acc
  }, {})
}

export function buildMediaQueryOnly(sizes: SizeMap) {
  return Object.entries(sizes).reduce((acc, [label, val]) => {
    if (val.min && val.max) {
      acc[label] = `@media (min-width: ${val.min}px) and (max-width: ${val.max}px)`
    }
    return acc
  }, {})
}

type MediaQueries = { [breakpoint in keyof typeof breakpointSizes]: string }

export const mediaQueryUp = buildMediaQueryUp(breakpointSizes) as MediaQueries
export const mediaQueryDown = buildMediaQueryDown(breakpointSizes) as MediaQueries
export const mediaQueryOnly = buildMediaQueryOnly(breakpointSizes) as MediaQueries

export default breakpointSizes
